// eslint-disable-next-line no-restricted-imports
import {
  Query_ClientController_GetList_AllOf_1_List_Items_Representative_IdentityDocument_Type as IdentityDocumentTypeApi,
  FullIdentityDocumentFragment,
} from 'api/generated/graphql';
import {
  FileTypeName,
  IdentityDocumentEntity,
  IdentityDocumentType,
} from 'api/types/entity';
import { lodash } from 'helpers';

import { parseFileDocumentEntity } from '../client/parseEntity/parseFileEntity';
import { parseCountryEntity } from '../parseCountryEntity';

const docType: Record<IdentityDocumentTypeApi, IdentityDocumentType> = {
  [IdentityDocumentTypeApi.IdCard]: IdentityDocumentType.IdCard,
  [IdentityDocumentTypeApi.Passport]: IdentityDocumentType.Passport,
};

export const parseIdentityDocumentWithFilesEntity = (
  data: FullIdentityDocumentFragment
): IdentityDocumentEntity => ({
  documentType: data.type ? docType[data.type] : undefined,
  authority: data.issuingAuthority ?? undefined,
  dateOfIssue: data.issueDate ? new Date(data.issueDate) : undefined,
  expirationDate: data.expirationDate
    ? new Date(data.expirationDate)
    : undefined,
  number: data.number ?? undefined,
  сountryOfIssue: data.issuingCountry
    ? parseCountryEntity(data.issuingCountry)
    : undefined,
  files: data.documents
    ? lodash.compact(data.documents).map((x) =>
        parseFileDocumentEntity({
          ...x,
          privateFile: {
            ...x.privateFile,
            type: FileTypeName.IdentityDocument,
          },
        })
      )
    : undefined,
});
